module.exports = __webpack_public_path__ + "files/12a7b64740b45d3b1884b0e1dd78131f.png";